export default defineNuxtPlugin(() => ({
  provide: {
    fetch: $fetch,
  },
}))
